/**
 * So sánh tên tiếng Việt:
 * - So sánh theo TÊN (từ cuối cùng) trước theo bảng chữ cái tiếng Việt (A, Ă, Â, B, C, D, Đ, ...)
 * - Nếu trùng tên thì so sánh tiếp theo toàn bộ HỌ VÀ TÊN ĐỆM
 */
export const compareVietnameseNames = (aName?: string, bName?: string): number => {
    const nameA = (aName || '').trim();
    const nameB = (bName || '').trim();

    if (!nameA && !nameB) return 0;
    if (!nameA) return 1;
    if (!nameB) return -1;

    const partsA = nameA.split(/\s+/);
    const partsB = nameB.split(/\s+/);

    const firstNameA = partsA[partsA.length - 1] || '';
    const firstNameB = partsB[partsB.length - 1] || '';

    const firstNameCompare = firstNameA.localeCompare(firstNameB, 'vi');
    if (firstNameCompare !== 0) {
        return firstNameCompare;
    }

    return nameA.localeCompare(nameB, 'vi');
};
